<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'PageHelp',
    inheritAttrs: false,
  });

  const componentMetadata = {
    kind: 'usercontrol',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({
    path: {
      type: String,
      required: true,
    },
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const baseUrl = ref(null);
  const ux = ref([]);
  const b_8358196963355853_style = computed(() => ({
    'font-size': '0.75em',
  }));

  const $data = computed(() => ({
    baseUrl: baseUrl.value,
    ux: ux.value,
    b_8358196963355853_style: b_8358196963355853_style.value,
  }));

  const $$load_baseUrl = async () => {
    return $app.value.vars.integro_docs_url;
  };

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [
      { name: 'baseUrl' },
      { name: 'ux' },
      { name: 'b_8358196963355853_style', nodeId: '8358196963355853' },
    ],
    loaders: { baseUrl: $$load_baseUrl },
    ux: {},
    dataRefs: { baseUrl, ux, b_8358196963355853_style },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  watch(
    () => props.path,
    (newValue, oldValue) => {
      if (_.isEqual(newValue, oldValue)) return;
      loadDataThrottled('path');
    }
  );

  const actions = {};

  defineExpose({
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <a
    :href="baseUrl + path"
    target="_blank"
    class="ms-auto d-inline-flex align-items-center gap-1"
  >
    <ItpIcon fa="question-circle"> </ItpIcon>
    <span class="mx-1">
      {{ gettext('Help') }}
    </span>
    <ItpIcon
      fa="external-link-alt"
      class="text-muted"
      :style="b_8358196963355853_style"
    >
    </ItpIcon>
  </a>
</template>
